// Reminders Management Permissions

export const REMINDERS_INDEX = 151;
export const REMINDERS_STORE = 152;
export const REMINDERS_DESTROY = 153;
export const REMINDERS_RESTORE = 1401;
// A filtered view of the same list.
export const REMINDERS_UPCOMING = REMINDERS_INDEX;

// Editing / completing a reminder — registered by the amer-laravel migration
// 2026_08_05_000008_add_crm_structure_refactor_permissions. The id is the
// central-assigned approval number and must be confirmed against the central
// permission-key registry before release.
/** reminders.update */
export const REMINDERS_UPDATE = 1446;
